import ReactController from '~/controllers/react_controller'
import AzureDatabaseDashboardCharts from '~/dashboard/azure_database_dashboard_charts'

export default class AzureDatabaseDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AzureDatabaseDashboardCharts organizationId={this.organizationIdValue} />
  }
}
